import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { tsdaBaseQuery } from './baseQuery';

export const trailNotebookCRF = createApi({
  baseQuery: tsdaBaseQuery,
  reducerPath: 'TrailNotebookCRF',
  endpoints: builder => ({
    getVisitsCRFOIDs: builder.query<any, any>({
      query: ({ site_id, study_id, country }) => ({
        url: `${formatString(endPoints.trailNotebookCRF.getVisitsCRFOIDs, {
          key: urlKeys.study_id,
          value: study_id
        })}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'GET'
      })
    }),
    getPatientsDetails: builder.query<any, any>({
      query: ({ parent_id, OID, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.getPatientsDetails,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.parent_id,
            value: parent_id
          },
          {
            key: urlKeys.OID,
            value: OID
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'GET'
      })
    }),
    createCRFData: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.createCRFData,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    selectCRFData: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.selectCRFData,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    selectCRFDataByID: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.selectCRFDataByID,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    updateCRFData: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.updateCRFData,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    getVisitLinkedCRFs: builder.query<any, any>({
      query: ({ study_id, site_id, country, visit_id, visit_name, mrn }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.getVisitLinkedCRFs,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.visit_id,
            value: visit_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}${
          visit_name !== null ? `&visit_name=${visit_name}` : ''
        }${
          mrn !== null ? `&mrn=${mrn}` : ''
        }&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'GET'
      })
    }),
    deleteAssociation: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.deleteAssociation,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    deleteAssociationEvent: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.deleteAssociationEvent,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    deleteCRFEvent: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.deleteCRFEvent,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    getCRFEvent: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.getCRFEvent,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    /** CTMSKANBAN-5655-5598 Start */
    getAllPatientVisits: builder.query<any, any>({
      query: ({ parent_id, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.getAllVisits,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.parent_id,
            value: parent_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,

        method: 'GET'
      })
    }),
    startVisit: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.startVisit,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),
    startVisitStatus: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.startVisitStatus,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'GET'
      })
    }),
    getVisitSpecificCRFOIDs: builder.query<any, any>({
      query: ({ visit_id, parent_id = '', site_id, study_id, country, visit_name }) => ({
        url: `${formatString(
          endPoints.trailNotebookCRF.getVisitCRFDetails,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.visit_id,
            value: visit_id
          }
        )}?site_id=${site_id}&study_id=${study_id}${
          parent_id !== '' ? `&parent_id=${parent_id}` : parent_id
        }&country=${country}&visit_name=${visit_name}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'GET'
      })
    }),
    tsdaCalendarView: builder.query<any, any>({
      query: ({ site_id, study_id, country, data, application = 'CTMS' }) => ({
        url: `${formatString(endPoints.trailNotebookCRF.tsdaCalendarView, {
          key: urlKeys.study_id,
          value: study_id
        })}?${country !== null ? `country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}`,
        method: 'POST',
        body: data
      })
    })
    /** CTMSKANBAN-5655-5598 End*/
  })
});

export const {
  useLazyGetVisitsCRFOIDsQuery,
  useLazyGetPatientsDetailsQuery,
  useCreateCRFDataMutation,
  useSelectCRFDataMutation,
  useUpdateCRFDataMutation,
  useLazyGetVisitLinkedCRFsQuery,
  useDeleteAssociationMutation,
  useDeleteAssociationEventMutation,
  useDeleteCRFEventMutation,
  useGetCRFEventMutation,
  useLazyGetAllPatientVisitsQuery,
  useStartVisitMutation,
  useStartVisitStatusMutation,
  useLazyGetVisitSpecificCRFOIDsQuery,
  useSelectCRFDataByIDMutation,
  useLazyTsdaCalendarViewQuery
} = trailNotebookCRF;
